import * as React from 'react';
import { useFeatureToggles } from '@grandvisionhq/state';
import { mapStepToRoute, steps } from '../steps.js';

const useDisableSteps = (active, queryParams)=>{
    const { featureConfigs  } = useFeatureToggles();
    const { appointmentBookingVirtualAppointmentTypeId  } = featureConfigs !== null && featureConfigs !== void 0 ? featureConfigs : {};
    const disabledSteps1 = React.useMemo(()=>{
        const disabledSteps = Object.keys(mapStepToRoute).map((step)=>Number(step)
        ).filter((step)=>step > active
        );
        const isVirtualAppointmentTypeId = queryParams.typeId === appointmentBookingVirtualAppointmentTypeId;
        /**  disable What step if typeId is virtual appointment type on the When or Who step */ if (isVirtualAppointmentTypeId && (active === steps.when || active === steps.who)) {
            disabledSteps.push(steps.what);
        }
        return disabledSteps;
    }, [
        active,
        queryParams,
        appointmentBookingVirtualAppointmentTypeId
    ]);
    return disabledSteps1;
};

export { useDisableSteps };
//# sourceMappingURL=use-disabled-steps.js.map
